var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12.835,
    viewBox: "0 0 20 12.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(-6.5 -10.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M22.768,10.393a.917.917,0,0,1,1.3,0l5.5,5.5a.917.917,0,0,1,0,1.3l-5.5,5.5a.918.918,0,1,1-1.3-1.3l4.852-4.851L22.767,11.69a.917.917,0,0,1,0-1.3Z",
    transform: "translate(-3.334 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M4.5,17.792a.876.876,0,0,1,.83-.917H22.75a.921.921,0,0,1,0,1.833H5.33A.876.876,0,0,1,4.5,17.792Z",
    transform: "translate(2 -1.251)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ea49208eeda83d66368bce20b17001e1.svg";
export { ForwardRef as ReactComponent };